import { Component } from '@angular/core';
import { MdbPopconfirmRef } from 'mdb-angular-ui-kit/popconfirm';

@Component({
  selector: 'app-pop-confirm',
  templateUrl: './pop-confirm.component.html',
  styleUrls: ['./pop-confirm.component.scss']
})
export class PopConfirmComponent {
  title: string;
  message: string;
  positiveButtonText: string = 'Ok';
  negativeButtonText: string = 'Cancel';

  constructor(private modalRef: MdbPopconfirmRef<PopConfirmComponent>) {}

  close(resp: boolean) {
    this.modalRef.close(resp)
  }

  confirm(resp: any) {
    this.modalRef.confirm(resp)
  }
}
